export default __webpack_public_path__ + "maps-guides-styles-layers-symbol-layer-icon-1200-6552f6e2b3efdfd05cf6c68b94920008.png";